import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { MtsBadge } from '@mts-ds/components-react';
import Typography from '../../../components_/Typography';

import { ICamera } from '../../../models/types';

import MarkerTooltip from './components/MarkerTooltip';

const useStyles = makeStyles(({ spacing, colors }) => ({
  content: {
    '& > *:not(:last-child)': {
      marginBottom: spacing(1)
    }
  },
  label: {
    '& > *:not(:last-child)': {
      marginRight: spacing(1)
    }
  }
}));

interface IProps {
  item: ICamera;
}

const CameraMarkerListItemTooltip: FC<IProps> = ({ item }) => {
  const { name, description } = item;

  const classes = useStyles();

  return (
    <MarkerTooltip>
      <Grid className={classes.content}>
        <MtsBadge size="s">Камера</MtsBadge>
        <Typography variant="p2Bold">{name}</Typography>
        <Typography variant="p3Regular">{description}</Typography>
      </Grid>
    </MarkerTooltip>
  );
};

export default CameraMarkerListItemTooltip;
